export default __webpack_public_path__ + "static/media/paint_splatter_large_1920_1080.4a6b3fdf.jpg";